
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Swiftdezirehireinpune() {



  const cardData =
  {
    keyword: 'Swift Dzire Hire in Pune',
    heading: 'SHREE Tours & Travels: Swift Dzire Hire in Pune',
    headingDescription: 'SHREE Tours & Travels offers Swift Dzire hire in Pune, providing a comfortable and budget-friendly travel option for local and outstation trips. Whether you need a one-way Cab, round trip, airport transfer, or corporate travel, our well-maintained Swift Dzire Cabs ensure a smooth and hassle-free journey. With professional drivers, on-time service and affordable fares, we guarantee a safe and enjoyable ride. Choose SHREE Tours & Travels for the best Swift Dzire rental service in Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in Pune, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand structure features intricate wooden architecture, massive gates and the famous 'Delhi Darwaza.' It is surrounded by gardens and fountains, making it a great spot for history enthusiasts. The light and sound show in the evening narrates the fort's rich history, adding to the experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is an architectural masterpiece and a symbol of India's freedom struggle. It served as a prison for Mahatma Gandhi and other freedom fighters during the Quit India Movement. The palace features Italian arches, sprawling gardens and a museum housing personal belongings of Mahatma Gandhi, making it a must-visit for history and heritage lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop a hill, Sinhagad Fort is one of Pune’s most famous trekking destinations. This historic fortress, associated with the Maratha warrior Tanaji Malusare, offers breathtaking views of the Sahyadri mountains. Visitors can explore the ancient ruins, enjoy local delicacies like 'pithla bhakri,' and experience the fort’s rich history while trekking through its scenic trails."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganpati Temple is dedicated to Lord Ganesha. Known for its grand Ganesh idol adorned with gold ornaments, the temple attracts thousands of devotees daily. The temple’s annual Ganesh festival is a grand spectacle, featuring magnificent decorations, cultural performances and a spiritual ambiance."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A fascinating museum housing over 20,000 artifacts, the Raja Dinkar Kelkar Museum showcases a diverse collection of sculptures, paintings, musical instruments and everyday objects from India’s past. The museum is particularly known for its replica of the Mastani Mahal, which provides a glimpse into the royal lifestyle of the Peshwas."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Carved out of a single rock in the 8th century, the Pataleshwar Cave Temple is dedicated to Lord Shiva. This ancient temple, featuring massive stone pillars and intricate carvings, is a peaceful retreat amidst Pune’s bustling city life. The temple’s unique architecture and serene atmosphere make it a hidden gem for history and spirituality seekers."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a beautiful artificial lake, ideal for nature lovers and bird watchers. Surrounded by lush greenery, the lake serves as a habitat for various migratory birds. The walking track along the lake makes it a perfect spot for morning walks, photography and peaceful relaxation away from the city’s hustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual center promoting meditation and wellness. Visitors can experience a range of meditation techniques, yoga sessions and rejuvenation therapies. The ashram's lush gardens, serene atmosphere and international community make it a unique place for self-discovery and relaxation."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal is a historic site closely associated with Chhatrapati Shivaji Maharaj, as it was his childhood residence. Though rebuilt, the palace features paintings and exhibits depicting Shivaji’s life and achievements. The site is of great historical importance and offers insights into the Maratha legacy."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Situated on the outskirts of Pune, Khadakwasla Dam is a popular picnic spot offering scenic views and a refreshing escape. The dam is a great place for photography, evening walks and enjoying street food like corn and chai. The nearby Sinhagad Fort and Panshet Dam make it a perfect getaway for adventure seekers and nature lovers."
    }
],  
    
            
"services": [
    {
      "name": "Swift Dzire Car Rental Pune",
      "description": "Rent a Swift Dzire in Pune for your travel needs. Our affordable car rental services offer you a comfortable ride with well-maintained vehicles. Perfect for both business and leisure trips."
    },
    {
      "name": "Swift Dzire Taxi Hire Pune",
      "description": "Book a Swift Dzire taxi in Pune for a reliable and smooth ride. Our professional drivers ensure a safe and comfortable journey, whether you're traveling locally or outstation."
    },
    {
      "name": "Book Swift Dzire in Pune",
      "description": "Looking for a Swift Dzire in Pune? We offer easy booking for this stylish, fuel-efficient car, ideal for both short and long-distance trips with family, friends, or colleagues."
    },
    {
      "name": "Affordable Swift Dzire Rental Pune",
      "description": "Get affordable Swift Dzire rental services in Pune without compromising on comfort or quality. Enjoy a pleasant drive at the best prices in the city."
    },
    {
      "name": "Swift Dzire for Outstation in Pune",
      "description": "Plan an outstation trip from Pune with a Swift Dzire. Our rental services provide you with a comfortable, fuel-efficient car for your journey to nearby destinations at competitive prices."
    },
    {
      "name": "Swift Dzire Hire for Local Travel",
      "description": "Rent a Swift Dzire for your local travel in Pune. Perfect for city tours, meetings and events, offering a smooth, comfortable and budget-friendly ride for your daily needs."
    },
    {
      "name": "Rent Swift Dzire for City Travel Pune",
      "description": "Explore Pune with ease by renting a Swift Dzire. Whether you're visiting local attractions, attending events, or running errands, enjoy a comfortable ride at an affordable rate."
    },
    {
      "name": "Swift Dzire Car Hire for Airport Transfer Pune",
      "description": "Book a Swift Dzire for your airport transfer in Pune. Our efficient car hire service ensures timely pickup and drop-off at the airport, offering a smooth and stress-free travel experience."
    },
    {
      "name": "Swift Dzire Rental for Family Travel",
      "description": "Looking for a family-friendly ride? Rent a Swift Dzire for family trips in Pune. With ample space and a comfortable ride, it's ideal for family vacations, outings, or gatherings."
    },
    {
      "name": "Swift Dzire for Group Travel in Pune",
      "description": "Traveling with a group? Hire a Swift Dzire for your group travel in Pune. With enough space to accommodate everyone, enjoy a relaxed, affordable journey to your destination."
    },
    {
      "name": "Swift Dzire Hire for Business Travel",
      "description": "Rent a Swift Dzire for your business travel in Pune. Whether you're attending meetings, conferences, or corporate events, this stylish car offers comfort, reliability and professionalism."
    },
    {
      "name": "Swift Dzire Hire for Corporate Travel Pune",
      "description": "Book a Swift Dzire for corporate travel in Pune. Our professional chauffeur service ensures timely arrivals for your business meetings and corporate events, providing a luxurious yet economical ride."
    },
    {
      "name": "Swift Dzire for Pune to Outstation Trip",
      "description": "Planning an outstation trip from Pune? Hire a Swift Dzire for a smooth and comfortable journey. With fuel efficiency and ample space, it's perfect for a relaxing trip to nearby cities."
    }
  ],
  "tableData": [
    ["- Swift Dzire Car Rental Pune", "- Swift Dzire Taxi Hire Pune"],
    ["- Book Swift Dzire in Pune", "- Affordable Swift Dzire Rental Pune"],
    ["- Swift Dzire for Outstation in Pune", "- Swift Dzire Hire for Local Travel"],
    ["- Rent Swift Dzire for City Travel Pune", "- Swift Dzire Car Hire for Airport Transfer Pune"],
    ["- Swift Dzire Rental for Family Travel", "- Swift Dzire for Group Travel in Pune"],
    ["- Swift Dzire Hire for Business Travel", "- Swift Dzire Hire for Corporate Travel Pune"],
    ["- Swift Dzire for Pune to Outstation Trip"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Stylish and Comfortable Ride",
      "WhyChoosedescription": "The Swift Dzire is the perfect choice for a stylish and comfortable ride in Pune. With its spacious interior, comfortable seating and smooth ride, it is ideal for both short and long trips. Whether you're traveling for business or leisure, the Swift Dzire offers a premium experience."
    },
    {
      "WhyChooseheading": "Affordable and Competitive Pricing",
      "WhyChoosedescription": "We offer Swift Dzire hire at affordable and competitive rates in Pune. Our pricing is transparent with no hidden charges, giving you great value for your money while ensuring that you travel in comfort and style. Enjoy budget-friendly options without compromising on quality."
    },
    {
      "WhyChooseheading": "Well-Maintained and Clean Vehicles",
      "WhyChoosedescription": "At SHREE Tours & Travels, we ensure that all our Swift Dzire vehicles are well-maintained and regularly serviced. Each car undergoes routine checks for cleanliness, safety and reliability, so you can enjoy a hassle-free, comfortable ride every time you book with us."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and professional, ensuring a smooth, safe and timely journey. They are well-versed with the best routes in Pune and focus on your comfort and safety throughout the ride, making your trip enjoyable and worry-free."
    },
    {
      "WhyChooseheading": "Perfect for Small Groups or Business Travel",
      "WhyChoosedescription": "The Swift Dzire is perfect for small groups, families, or business travelers. With its spacious seating and efficient fuel economy, it provides a comfortable ride for a group of up to four people. Whether you're attending meetings or heading for a weekend getaway, the Swift Dzire is a practical and efficient choice."
    },
    {
      "WhyChooseheading": "Easy and Quick Booking Process",
      "WhyChoosedescription": "Booking a Swift Dzire with SHREE Tours & Travels is simple and convenient. You can quickly book online through our easy-to-use platform, or contact our customer support team for assistance. We ensure a seamless booking experience for your travel needs."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Our Swift Dzire hire service in Pune is available 24/7, so you can book a ride whenever it suits your schedule. Whether it’s early in the morning or late at night, we are always available to provide you with dependable, timely and comfortable transportation."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "Customer satisfaction is our top priority. We are committed to providing the best service for every Swift Dzire ride in Pune. With a focus on comfort, safety and punctuality, we guarantee a smooth and pleasant journey that will leave you satisfied with our service."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  



        
  }
  const faqData = [
    {
        question: "How can I hire a Swift Dzire in Pune?",
        answer: "You can easily hire a Swift Dzire in Pune through our website or by calling our customer service for personalized assistance."
    },
    {
        question: "What is the rental rate for a Swift Dzire in Pune?",
        answer: "Rental rates for a Swift Dzire vary depending on the duration and type of trip. Please contact us for detailed pricing information."
    },
    {
        question: "Is the rental rate for the Swift Dzire inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I hire a Swift Dzire for a one-way trip in Pune?",
        answer: "Yes, we offer one-way rental options for the Swift Dzire in Pune and surrounding areas."
    },
    {
        question: "Do you provide drivers with the Swift Dzire hire in Pune?",
        answer: "Yes, all our Swift Dzire rentals come with experienced drivers who are familiar with the local routes to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for Swift Dzire bookings in Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for Swift Dzire bookings in Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the Swift Dzire vehicles insured for safety during trips?",
        answer: "Yes, all our vehicles, including the Swift Dzire, are fully insured for your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my Swift Dzire hire in Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for hiring a Swift Dzire in Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I hired a Swift Dzire from SHREE Tours & Travels for a business trip in Pune. The car was clean, comfortable and the driver was very professional.',
        name: 'Mr. Arjun Gupta',
    },
    {
        text: 'SHREE Tours & Travels offers excellent Swift Dzire hire services. The ride was smooth and I had a pleasant experience during my time in Pune.',
        name: 'Miss. Rina Desai',
    }
];














  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];
const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Rent a Swift Dzire car in Pune for affordable and comfortable travel. We offer Swift Dzire car rentals for local travel, outstation trips, airport transfers, family travel, group travel and more. Call +91 9594917913 to book!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/swift-dzire-rental.jpg",
    "https://shreetoursandtravels.in/img/swift-dzire-outstation.jpg"
  ],
  "priceRange": "₹1500 - ₹4000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/swift-dzire-hire-pune",
    "priceCurrency": "INR",
    "price": 2500,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 850
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Amit Deshmukh"
      },
      "datePublished": "2024-10-12",
      "reviewBody": "Excellent service! The Swift Dzire was comfortable and perfect for our group trip from Pune to Mahabaleshwar. The driver was professional and made the journey smooth. Highly recommend SHREE Tours & Travels!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Meera Joshi"
      },
      "datePublished": "2024-11-05",
      "reviewBody": "Great experience renting a Swift Dzire for a family trip to Pune. The car was clean and well-maintained. Very affordable rental prices and professional service. Would definitely book again!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Swift Dzire Hire Service in Pune",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/swift-dzire-hire-pune"
  },
  "keywords": "Swift Dzire Car Rental Pune, Swift Dzire Taxi Hire Pune, Book Swift Dzire in Pune, Affordable Swift Dzire Rental Pune, Swift Dzire for Outstation in Pune, Swift Dzire Hire for Local Travel, Rent Swift Dzire for City Travel Pune, Swift Dzire Car Hire for Airport Transfer Pune, Swift Dzire Rental for Family Travel, Swift Dzire for Group Travel in Pune, Swift Dzire Hire for Business Travel, Swift Dzire Hire for Corporate Travel Pune, Swift Dzire for Pune to Outstation Trip"
};





  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Swift Dzire Hire in Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Rent a Swift Dzire car in Pune for affordable and comfortable travel. We offer Swift Dzire car rentals for local travel, outstation trips, airport transfers, family travel, group travel and more. Call +91 9594917913 to book!" />
  <meta name="keywords" content="Swift Dzire Car Rental Pune, Swift Dzire Taxi Hire Pune, Book Swift Dzire in Pune, Affordable Swift Dzire Rental Pune, Swift Dzire for Outstation in Pune, Swift Dzire Hire for Local Travel, Rent Swift Dzire for City Travel Pune, Swift Dzire Car Hire for Airport Transfer Pune, Swift Dzire Rental for Family Travel, Swift Dzire for Group Travel in Pune, Swift Dzire Hire for Business Travel, Swift Dzire Hire for Corporate Travel Pune, Swift Dzire for Pune to Outstation Trip" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/22.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Swiftdezirehireinpune;